<template>
  <div id="calendar">
    <MyAvailability :show.sync="showAvailability" />
    <MyCalendar :show.sync="showCalendar" />
  </div>
</template>

<script>
import MyAvailability from './MyAvailability.vue';
import MyCalendar from './MyCalendar.vue';

export default {
  components: {
    MyAvailability,
    MyCalendar,
  },

  data() {
    return {
      showAvailability: false,
      showCalendar: true,
    };
  },

  watch: {
    showAvailability(newVal) {
      if (newVal) {
        this.showCalendar = false;
      }
    },

    showCalendar(newVal) {
      if (newVal) {
        this.showAvailability = false;
      }
    },
  },

  created() {
    if (this.$route.query.availabilities || this.$route.query.availabilities === null) {
      this.showAvailability = true;
      this.MyCalendar = true;
    }
  },

};
</script>

<style lang="scss" scoped>
#calendar {
  #myAvailability {
    margin-bottom: 15px;
  }
}
</style>
